let idCounter = 0
const nextId = () => `familyTree_${Date.now()}_${idCounter++}`

export function createInitialFamilyTree (config, clientId) {
  const nodes = []
  const edges = []

  const familyTreeConfig = config?.familyTree || config || {}
  const { slotCount = 50, defaultNodeType = 'familyTreeNode' } = familyTreeConfig

  for (let i = 0; i < slotCount; i++) {
    const slotId = nextId()
    nodes.push({
      id: slotId,
      type: defaultNodeType,
      position: { x: 0, y: 0 },
      data: {
        slotIndex: i,
        isSlot: true,
        nodeProps: { size: 'md', handles: [], targets: [] }
      },
      displayOptions: {
        image: 'entityProps.data.avatarUrl',
        header: 'entityProps.data.label',
        description: 'entityProps.data.description'
      }
    })
  }

  return { nodes, edges, centerId: null }
}
